// removed by extract-text-webpack-plugin
module.exports = {"container":"nmaZMQPLTkcZ3_Xg3DLz0","iconContainer":"yN653V0RH6OFo_ES85tMI","icon":"_1SUFHA8rk1UcF_YYyEM81P","megascans":"Za2DGHvbzf9hkyAfD62p0","unreal":"_1S1sEUBWGGKm-s6ist4TwT","heading":"_10dVXSU-nxjN5R-3Jmx09S","para":"_3C7Khv3-gUNlrtSzeRvcEL","actionButton":"_2aNWYuskzGf6XuU2rZLQ3H","footer":"_3Xby-xuKm1CKAvSj4oVF8L"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SwitchPlans.scss
// module id = 2973
// module chunks = 0